import React, {

  useCallback,

  useEffect,

  useLayoutEffect,

  useMemo,

  useRef,

  useState,

} from "react";

import { useNavigate } from "react-router-dom";

import {

  collection,

  deleteField,

  doc,

  increment,

  onSnapshot,

  serverTimestamp,

  setDoc,

  Timestamp,

  writeBatch,

} from "firebase/firestore";

import { updateScore } from "../../api/scoreApi";

import { sendReport } from "../../functions/sendReport";



import { database } from "../../database/firebase";

import icon1 from "../../img/icon1.png";

import icon2 from "../../img/icon2.png";

import icon3 from "../../img/icon3.png";

import icon4 from "../../img/icon4.png";

import icon5 from "../../img/icon5.png";

import icon6 from "../../img/icon6.png";

import icon7 from "../../img/icon7.png";

import icon8 from "../../img/icon8.png";
import MonkeyBackdrop from "../../components/MonkeyBackdrop";

import {

  computeTruthRoundScores,

  SCORE_CORRECT_GUESS,

  SCORE_PER_PLAYER_FOOLED,

} from "../../utils/truthGameScoring";

import "./game.css";

import { flushSync } from "react-dom";

import LeaderboardConfetti from "../../components/LeaderboardConfetti";



const PLAYER_ICONS = [icon1, icon2, icon3, icon4, icon5, icon6, icon7, icon8];

const LOBBY_COLLECTION = "lobby";

const LOBBY_USERDATA = "userdata";

const GUEST_LOBBY_USER_KEY = "truthLobbyGuestUserId";



const SLOT_KEYS = ["truth1", "truth2", "lie"];

/** Synced guessing window for each spotlight round. */

const DEFAULT_ROUND_SECONDS = 60;



/** Room is in the spot-the-lie phase (`holding` is written from waiting; `show` kept for older rooms). */

function isTruthGamePlayPhase(status) {

  const s = String(status ?? "").trim().toLowerCase();

  return s === "holding" || s === "show";

}

function uuidv4() {

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {

    const r = Math.random() * 16 | 0;

    const v = c === 'x' ? r : (r & 0x3 | 0x8);

    return v.toString(16);

  });

}

/** Green “truth” tile with smile (replaces TRUTH / truth text when revealed). */

function TruthFaceSvg() {

  return (

    <svg

      className="game__card-face-svg"

      viewBox="0 0 48 48"

      width="48"

      height="48"

      aria-hidden

      focusable="false"

    >

      <rect

        x="4"

        y="4"

        width="40"

        height="40"

        rx="9"

        fill="#4ade80"

        stroke="#fff"

        strokeWidth="3"

      />

      <circle cx="17" cy="19" r="3.2" fill="#fff" />

      <circle cx="31" cy="19" r="3.2" fill="#fff" />

      <path

        d="M 15 27 Q 24 37 33 27"

        fill="none"

        stroke="#fff"

        strokeWidth="2.5"

        strokeLinecap="round"

      />

      <ellipse cx="24" cy="30" rx="5" ry="3.2" fill="#fb7185" />

    </svg>

  );

}



/** Red “lie” tile with X eyes and frown (replaces LIE / lie text when revealed). */

function LieFaceSvg() {

  return (

    <svg

      className="game__card-face-svg"

      viewBox="0 0 48 48"

      width="48"

      height="48"

      aria-hidden

      focusable="false"

    >

      <rect

        x="4"

        y="4"

        width="40"

        height="40"

        rx="9"

        fill="#ef4444"

        stroke="#fff"

        strokeWidth="3"

      />

      <path

        d="M 13 15 L 19 21 M 19 15 L 13 21"

        stroke="#fff"

        strokeWidth="2.3"

        strokeLinecap="round"

      />

      <path

        d="M 29 15 L 35 21 M 35 15 L 29 21"

        stroke="#fff"

        strokeWidth="2.3"

        strokeLinecap="round"

      />

      <path

        d="M 16 33 Q 24 25 32 33"

        fill="none"

        stroke="#fff"

        strokeWidth="2.5"

        strokeLinecap="round"

      />

    </svg>

  );

}



function CardRevealFaceBadge({ isLie }) {

  return (

    <span

      className={`game__card-reveal-face game__card-reveal-face--${isLie ? "lie" : "truth"

        }`}

      role="img"

      aria-label={isLie ? "Lie" : "Truth"}

    >

      {isLie ? <LieFaceSvg /> : <TruthFaceSvg />}

    </span>

  );

}



/** After a guess: which icon to show at the bottom of each card (null = none). */

function pickCardResultKind(slot, myPick) {

  if (!myPick) return null;

  if (slot === myPick) return myPick === "lie" ? "correct" : "wrong";

  if (slot === "lie" && myPick !== "lie") return "answer";

  return null;

}



/** Live avatars on a card: everyone sees who chose this statement (synced + local pending). */

function CardPickerStack({ userIds, userMap, compact }) {

  if (!userIds?.length) return null;

  const max = 6;

  const shown = userIds.slice(0, max);

  const extra = userIds.length - shown.length;

  return (

    <div

      className={`game__card-pickers${compact ? " game__card-pickers--compact" : ""}`}

      aria-label={`Chosen by ${userIds.length} player${userIds.length === 1 ? "" : "s"}`}

    >

      {shown.map((uid) => (

        <img

          key={uid}

          src={avatarIconForUserId(uid)}

          alt=""

          title={displayNameForUser(uid, userMap.get(uid))}

          className="game__card-picker-icon"

          width={28}

          height={28}

        />

      ))}

      {extra > 0 ? (

        <span className="game__card-picker-more" aria-hidden>

          +{extra}

        </span>

      ) : null}

    </div>

  );

}



function CardResultFooter({ kind }) {

  if (!kind) return null;

  const sr =

    kind === "correct"

      ? "Correct — you found the lie."

      : kind === "wrong"

        ? "Wrong — not the lie."

        : "The lie was here.";

  const isCheck = kind === "correct" || kind === "answer";

  return (

    <div

      className={`game__card-result game__card-result--${kind}`}

      role="img"

      aria-label={sr}

    >

      {isCheck ? (

        <svg

          className="game__card-result-svg"

          viewBox="0 0 24 24"

          width="28"

          height="28"

          aria-hidden

          focusable="false"

        >

          <path

            fill="currentColor"

            d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"

          />

        </svg>

      ) : (

        <svg

          className="game__card-result-svg"

          viewBox="0 0 24 24"

          width="28"

          height="28"

          aria-hidden

          focusable="false"

        >

          <path

            fill="currentColor"

            d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"

          />

        </svg>

      )}

    </div>

  );

}



function GameHoldTightPanel({ hint, userMap }) {

  const holdTightIcons = useMemo(() => {
    if (!(userMap instanceof Map) || userMap.size <= 0) return [];
    const entries = [];
    userMap.forEach((data, id) => {
      if (!hasCompleteStatements(data)) return;
      const uid = String(id ?? "").trim();
      if (!uid) return;
      const name = displayNameForUser(uid, data);
      entries.push({ uid, data, name });
    });
    entries.sort((a, b) =>
      a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
    );
    return entries.map(({ uid, data }) => avatarIconForUser(uid, data));
  }, [userMap]);

  return (

    <div className="game__hold-tight" role="status">

      <div className="game__hold-tight-inner">

        <h2 className="game__hold-tight-title">Hold tight!</h2>

        <div className="game__hold-tight-icons" aria-hidden>

          {holdTightIcons.map((src, i) => (

            <img

              key={i}

              src={src}

              alt=""

              className="game__hold-tight-icon"

              style={{ animationDelay: `${i * 0.14}s` }}

            />

          ))}

        </div>

        <p className="game__hold-tight-hint">{hint}</p>

      </div>

    </div>

  );

}



function avatarIconForUserId(userId) {

  let h = 0;

  const s = String(userId);

  for (let i = 0; i < s.length; i += 1) {

    h = (Math.imul(31, h) + s.charCodeAt(i)) | 0;

  }

  return PLAYER_ICONS[Math.abs(h) % PLAYER_ICONS.length];

}

function avatarIconForUser(userId, userData) {

  const max = PLAYER_ICONS.length;
  const rawIndex = Number(userData?.characterIndex);
  if (Number.isFinite(rawIndex) && rawIndex >= 0 && rawIndex < max) {
    return PLAYER_ICONS[Math.floor(rawIndex)];
  }
  const rawCharacter = String(userData?.character ?? "").trim().toLowerCase();
  const match = rawCharacter.match(/^character_(\d+)$/);
  if (match) {
    const idx = Number(match[1]) - 1;
    if (Number.isFinite(idx) && idx >= 0 && idx < max) {
      return PLAYER_ICONS[idx];
    }
  }
  return avatarIconForUserId(userId);

}



function readSessionUser() {

  try {

    const raw = sessionStorage.getItem("userData");

    if (!raw) return null;

    const u = JSON.parse(raw);

    if (!u || typeof u !== "object") return null;

    const userId = String(u?.userId ?? u?.userid ?? "").trim();

    return { ...u, userId };

  } catch {

    return null;

  }

}



function readTruthLobby() {

  try {

    const raw = sessionStorage.getItem("truthLobby");

    if (!raw) return null;

    const o = JSON.parse(raw);

    if (!o || typeof o !== "object") return null;

    const sessionId = String(o.sessionId ?? "").trim();

    const lobbyId = String(o.lobbyId ?? "").trim();

    if (!sessionId || !lobbyId) return null;

    return o;

  } catch {

    return null;

  }

}



function resolvePlayerUserId() {

  const u = readSessionUser();

  if (u?.userId) return String(u.userId).trim();

  try {

    const g = sessionStorage.getItem(GUEST_LOBBY_USER_KEY);

    if (g && String(g).trim()) return String(g).trim();

  } catch {

    /* ignore */

  }

  return "";

}



function getUserDataForApi(userId, userMap, truthLobby) {

  const userData = userMap.get(userId);

  const sessionUser = readSessionUser();

  return {

    userId,

    sessionId: sessionUser?.sessionId || truthLobby?.sessionId || "",

    organizationId: sessionUser?.organizationId || "",

    name: displayNameForUser(userId, userData),

    email: sessionUser?.email || "",

    roles: sessionUser?.roles || "ORG_USER",

    reportId: sessionUser?.reportId || "",

  };

}



async function updateScoreWithRole(userData, totalPoints, time = "00:00") {

  console.log("userData", userData);

  const reportdata = {

    gameId: userData.gameId,

    name: userData.name,

    sessionId: userData.sessionId,

    userId: userData.userId,

    organizationId: userData.organizationId,

    points: totalPoints,

    reportId: userData.reportId,

    time,

    token: userData.token || "",

    role: userData.roles || userData.user_type

  }

  try {

    await sendReport(reportdata);

  } catch (error) {

    console.error("Failed to update score with role:", error);

    throw error;

  }

}



/** Deterministic shuffle so every client shows the same card order. */

function mulberry32(seed) {

  let a = seed >>> 0;

  return () => {

    a |= 0;

    a = (a + 0x6d2b79f5) | 0;

    let t = Math.imul(a ^ (a >>> 15), 1 | a);

    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;

    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;

  }

}



function shuffleSlots(seed, slots) {

  const arr = [...slots];

  const rnd = mulberry32(seed);

  for (let i = arr.length - 1; i > 0; i -= 1) {

    const j = Math.floor(rnd() * (i + 1));

    const t = arr[i];

    arr[i] = arr[j];

    arr[j] = t;

  }

  return arr;

}



function hashSeed(parts) {

  let h = 2166136261;

  const s = parts.join("|");

  for (let i = 0; i < s.length; i += 1) {

    h ^= s.charCodeAt(i);

    h = Math.imul(h, 16777619);

  }

  return h >>> 0;

}



function hasCompleteStatements(d) {

  const t1 = String(d?.truth1 ?? "").trim();

  const t2 = String(d?.truth2 ?? "").trim();

  const lie = String(d?.lie ?? "").trim();

  return Boolean(t1 && t2 && lie);

}

/** In-round participants: only users with all three lines saved (see waiting fill). */
function countUsersWithCompleteStatements(userMap) {
  if (!(userMap instanceof Map) || userMap.size <= 0) return 0;
  let n = 0;
  userMap.forEach((data) => {
    if (hasCompleteStatements(data)) n += 1;
  });
  return n;
}



function displayNameForUser(userId, data) {

const n = String(data?.name ?? "").trim();

if (n) return n;

const id = String(userId ?? "").trim();

return id ? id.slice(0, 10) : "Player";

}



function generateRevealMessage(guesserName, isCorrect, subjectName) {

if (isCorrect) {

const correctMessages = [

`Caught in the act, ${guesserName}!`,

`Nice detective work, ${guesserName}!`,

`${guesserName} spotted the lie!`,

`${guesserName} saw right through it!`,

`Busted! ${guesserName} found the lie.`

];

return correctMessages[Math.floor(Math.random() * correctMessages.length)];

} else {

const fooledMessages = [

`Wow! ${subjectName} totally fooled ${guesserName}!`,

`${guesserName} fell for ${subjectName}'s trick!`,

`${subjectName} had ${guesserName} completely fooled!`,

`Nice try, ${guesserName}! ${subjectName} got you.`

];

return fooledMessages[Math.floor(Math.random() * fooledMessages.length)];

}

}



function truthScoreFromUserData(d) {

  return Number(d?.truthGameScore ?? 0) || 0;

}



function buildEligibleGuessersForSubject(userMap, subjectUserId) {

  const list = [];

  userMap.forEach((data, id) => {

    if (id === subjectUserId) return;

    if (!hasCompleteStatements(data)) return;

    list.push(id);

  });

  return list;

}



function shuffleUserIds(ids) {

  const a = [...ids];

  for (let i = a.length - 1; i > 0; i -= 1) {

    const j = Math.floor(Math.random() * (i + 1));

    const t = a[i];

    a[i] = a[j];

    a[j] = t;

  }

  return a;

}



function resolveRoundEndMs(roomData) {

  const re = roomData?.gameRoundEndsAt;

  if (re == null) return null;

  if (typeof re.toMillis === "function") return re.toMillis();

  if (typeof re.toDate === "function") {

    const d = re.toDate();

    if (d instanceof Date && !Number.isNaN(d.getTime())) return d.getTime();

  }

  if (re instanceof Date && !Number.isNaN(re.getTime())) return re.getTime();

  if (typeof re === "number" && Number.isFinite(re)) return re;

  if (typeof re === "object" && typeof re.seconds === "number") {

    const ns = typeof re.nanoseconds === "number" ? re.nanoseconds : 0;

    return re.seconds * 1000 + Math.floor(ns / 1e6);

  }

  return null;

}



function formatSecondsAsMmSs(totalSecs) {

  const s = Math.max(0, Math.floor(Number(totalSecs) || 0));

  const minutes = Math.floor(s / 60);

  const sec = s % 60;

  return `${String(minutes).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;

}

function normalizeWholeSeconds(value, fallback = 0) {

  const n = Number(value);

  if (!Number.isFinite(n)) return Math.max(0, Math.floor(Number(fallback) || 0));

  return Math.max(0, Math.floor(n));

}

function resolveTotalGuessSeconds(userDoc, overrideSeconds) {

  if (overrideSeconds != null) return normalizeWholeSeconds(overrideSeconds, 0);

  return normalizeWholeSeconds(

    userDoc?.lastGuessTimeSeconds ??
      userDoc?.truthGameGuessTimeSecondsTotal ??
      userDoc?.guessTimeSeconds ??
      0,

    0

  );

}



function userdataDocRef(db, sessionId, roomId, uid) {

  return doc(

    db,

    LOBBY_COLLECTION,

    sessionId,

    "rooms",

    roomId,

    LOBBY_USERDATA,

    uid

  );

}



/** Clear synced picks so the next spotlight round starts fresh for everyone. */

function batchClearUserGuessPicks(batch, db, sessionId, roomId, userIds) {

  for (const uid of userIds) {

    if (!uid) continue;

    batch.set(

      userdataDocRef(db, sessionId, roomId, uid),

      {

        guessPick: deleteField(),

        guessedAt: deleteField(),

        guessTimeSeconds: deleteField(),

        guessEpoch: 0,

      },

      { merge: true }

    );

  }

}



async function commitScoreDeltas({

  db,

  sessionId,

  roomId,

  deltas,

  roomPatch,

  userMap,

  truthLobby,

  apiGuessTimeTotalByUid = null,

}) {

  const roomRef = doc(db, LOBBY_COLLECTION, sessionId, "rooms", roomId);

  const batch = writeBatch(db);



  // Update scores in Firebase and via API

  for (const [uid, delta] of deltas) {

    if (!delta) continue;



    const uref = doc(

      db,

      LOBBY_COLLECTION,

      sessionId,

      "rooms",

      roomId,

      LOBBY_USERDATA,

      uid

    );

    const userDoc = userMap.get(uid);

    const override =

      apiGuessTimeTotalByUid != null ? apiGuessTimeTotalByUid.get(uid) : undefined;

    const totalGuessSecs = resolveTotalGuessSeconds(userDoc, override);

    const formattedTime = formatSecondsAsMmSs(totalGuessSecs);

    batch.set(

      uref,

      {

        truthGameScore: increment(delta),

        truthGameScoreUpdatedAt: serverTimestamp(),

        lastGuessTimeSeconds: totalGuessSecs,

      },

      { merge: true }

    );



    // Update score via API

    try {

      const apiUserData = getUserDataForApi(uid, userMap, truthLobby);

      const currentScore = truthScoreFromUserData(userDoc);

      const nextScore = currentScore + delta;

      await updateScoreWithRole(apiUserData, nextScore, formattedTime);



      // Also update basic score

      await updateScore({

        userId: uid,

        sessionId: apiUserData.sessionId,

        organizationId: apiUserData.organizationId,

        points: nextScore,

        time: formattedTime,

      });

    } catch (apiError) {

      console.error(`Failed to update score for user ${uid}:`, apiError);

    }

  }



  batch.set(roomRef, roomPatch, { merge: true });

  await batch.commit();

}



function Game({ updateHeader }) {

  useEffect(() => {

    updateHeader({

      backButtonRedirect: "/rules",

      // ...(companyLogo ? { imageUrl: companyLogo } : {}),

    });

  }, []);



  const navigate = useNavigate();

  const [truthLobby, setTruthLobby] = useState(() => readTruthLobby());

  const [roomData, setRoomData] = useState(null);

  const [roomStatus, setRoomStatus] = useState("waiting");

  const [userMap, setUserMap] = useState(() => new Map());

  const [listenErr, setListenErr] = useState("");

  const [roomHydrated, setRoomHydrated] = useState(false);

  const [nextBusy, setNextBusy] = useState(false);

  const [resetTimerBusy, setResetTimerBusy] = useState(false);

  const [guessBusy, setGuessBusy] = useState(false);

  /** Shown immediately on tap so the card highlights before Firestore echoes the pick. */

  const [pickPending, setPickPending] = useState(null);

  const [presenterError, setPresenterError] = useState("");

  const [autoplayOn, setAutoplayOn] = useState(false);

  const [showEndRoundOptions, setShowEndRoundOptions] = useState(false);

  const [soundOn, setSoundOn] = useState(true);

  const [showConfetti, setShowConfetti] = useState(false);

  const [roundSecondsLeft, setRoundSecondsLeft] = useState(() => -1);
  const [, setTimerStarted] = useState(false);

  const initGameRef = useRef(false);

  const scoringFlightRef = useRef(false);
  const confettiRoundKeyRef = useRef("");



  useEffect(() => {

    setTruthLobby(readTruthLobby());

  }, []);



  const sessionId = String(truthLobby?.sessionId ?? "").trim();

  const roomId = String(truthLobby?.lobbyId ?? "").trim();



  useEffect(() => {

    initGameRef.current = false;

  }, [sessionId, roomId]);

  const me = resolvePlayerUserId();



  useEffect(() => {

    if (!sessionId || !roomId) return undefined;

    const roomRef = doc(

      database,

      LOBBY_COLLECTION,

      sessionId,

      "rooms",

      roomId

    );

    const unsubRoom = onSnapshot(

      roomRef,

      (snap) => {

        setListenErr("");

        setRoomHydrated(true);

        if (!snap.exists()) {

          setRoomData(null);

          setRoomStatus("waiting");

          return;

        }

        const data = snap.data();

        setRoomData(data);

        let st = String(data?.status ?? "").trim().toLowerCase();

        if (

          !st &&

          (data?.gameSubjectUserId ||

            data?.gameGuessEpoch != null ||

            (Array.isArray(data?.gameStatementOrder) &&

              data.gameStatementOrder.length > 0) ||

            data?.gameRoundEndsAt)

        ) {

          st = "holding";

        }

        if (!st) st = "waiting";

        setRoomStatus(st);

      },

      (err) => {

        console.error("game room:", err);

        setRoomHydrated(true);

        setListenErr(err?.message || "Room unavailable.");

      }

    );

    return () => unsubRoom();

  }, [sessionId, roomId]);



  useEffect(() => {

    if (!sessionId || !roomId) return undefined;

    const col = collection(

      database,

      LOBBY_COLLECTION,

      sessionId,

      "rooms",

      roomId,

      LOBBY_USERDATA

    );

    const unsub = onSnapshot(

      col,

      (snap) => {

        setListenErr("");

        const m = new Map();

        snap.docs.forEach((d) => {

          m.set(d.id, d.data());

        });

        setUserMap(m);

      },

      (err) => {

        console.error("game userdata:", err);

        setListenErr(err?.message || "Players unavailable.");

      }

    );

    return () => unsub();

  }, [sessionId, roomId]);



  /** Send players back to waiting until the room is in the reveal / guess phase (`holding` / `show`). */

  useEffect(() => {

    if (!sessionId || !roomId || !roomHydrated) return;

    if (isTruthGamePlayPhase(roomStatus)) return;

    if (roomStatus === "fill" || roomStatus === "waiting") {

      navigate("/waiting", { replace: true });

    }

  }, [sessionId, roomId, roomStatus, roomHydrated, navigate]);



  const isShowPhase =

    roomData?.gameFinished !== true &&

    (isTruthGamePlayPhase(roomStatus) ||

      isTruthGamePlayPhase(roomData?.status));



  useEffect(() => {

    if (!sessionId || !roomId || !roomHydrated) return;

    if (roomData?.gameFinished === true) {

      navigate("/leaderboard", { replace: true });

    }

  }, [roomData?.gameFinished, sessionId, roomId, roomHydrated, navigate]);



  const isPresenter = useMemo(() => {

    const gm = String(truthLobby?.gameMode ?? "").trim().toLowerCase();

    if (gm === "player") return false;

    const pid = String(

      roomData?.presenterUserId ?? truthLobby?.presenterUserId ?? ""

    ).trim();

    return Boolean(me && pid && pid === me);

  }, [

    me,

    roomData?.presenterUserId,

    truthLobby?.presenterUserId,

    truthLobby?.gameMode,

  ]);



  const presenterUserId = String(

    roomData?.presenterUserId ?? truthLobby?.presenterUserId ?? ""

  ).trim();



  const subjectsOrdered = useMemo(() => {

    const ids = [];

    userMap.forEach((data, id) => {

      if (hasCompleteStatements(data)) ids.push(id);

    });

    ids.sort();

    return ids;

  }, [userMap]);



  const statementOrder = useMemo(() => {

    const o = roomData?.gameStatementOrder;

    if (Array.isArray(o) && o.length > 0) {

      return o
        .map((id) => String(id).trim())
        .filter((id) => Boolean(id) && hasCompleteStatements(userMap.get(id)));

    }

    return subjectsOrdered;

  }, [roomData?.gameStatementOrder, subjectsOrdered, userMap]);



  const roundIdx = Math.max(0, Math.floor(Number(roomData?.gameRoundIdx ?? 0)) || 0);

  const subjectFromOrder =

    statementOrder.length > 0 && roundIdx < statementOrder.length

      ? String(statementOrder[roundIdx]).trim()

      : "";

  const subjectFromRoom = String(roomData?.gameSubjectUserId ?? "").trim();
  const subjectFromRoomIsEligible =
    Boolean(subjectFromRoom) && hasCompleteStatements(userMap.get(subjectFromRoom));
  const fallbackEligibleSubject =
    statementOrder.length > 0 ? String(statementOrder[0] ?? "").trim() : "";
  const subjectUserId =
    subjectFromOrder ||
    (subjectFromRoomIsEligible ? subjectFromRoom : fallbackEligibleSubject);



  // Debug logging for round index tracking

  // console.log("Round index calculation:", {

  //   roomDataGameRoundIdx: roomData?.gameRoundIdx,

  //   calculatedRoundIdx: roundIdx,

  //   statementOrder,

  //   subjectFromOrder,

  //   subjectUserId

  // });

  const guessEpoch = Number(roomData?.gameGuessEpoch ?? 1) || 1;



  const subjectDoc = subjectUserId ? userMap.get(subjectUserId) : null;

  const subjectName = subjectUserId

    ? displayNameForUser(subjectUserId, subjectDoc)

    : "";



  const storedRoomStatus = useMemo(

    () => String(roomData?.status ?? roomStatus ?? "").trim().toLowerCase(),

    [roomData?.status, roomStatus]

  );

  const isHoldingStatus = storedRoomStatus === "holding";

  const isShowStatus = storedRoomStatus === "show";

  const hasPresenterDock = isPresenter && (isHoldingStatus || isShowStatus);



  const showHoldingHoldTight = useMemo(

    () => isShowPhase && isHoldingStatus,

    [isShowPhase, isHoldingStatus]

  );



  const holdingHoldTightHint = isPresenter

    ? "Press Start when you're ready to open guesses for everyone."

    : "Waiting for the presenter to start this round.";



  const cardOrder = useMemo(() => {

    if (!subjectUserId) return SLOT_KEYS;

    const seed = hashSeed([sessionId, roomId, subjectUserId, String(guessEpoch)]);

    return shuffleSlots(seed, SLOT_KEYS);

  }, [sessionId, roomId, subjectUserId, guessEpoch]);



  const eligibleGuessers = useMemo(() => {

    if (!subjectUserId) return [];

    const list = [];

    userMap.forEach((data, id) => {

      if (id === subjectUserId) return;

      if (!hasCompleteStatements(data)) return;

      list.push(id);

    });

    return list;

  }, [userMap, subjectUserId]);



  const eligibleGuessersSorted = useMemo(

    () =>

      [...eligibleGuessers].sort((a, b) =>

        displayNameForUser(a, userMap.get(a)).localeCompare(

          displayNameForUser(b, userMap.get(b)),

          undefined,

          { sensitivity: "base" }

        )

      ),

    [eligibleGuessers, userMap]

  );



  const myData = me ? userMap.get(me) : null;

  const myGuessEpoch = Number(myData?.guessEpoch ?? 0) || 0;

  const myPick =

    myGuessEpoch === guessEpoch && myData?.guessPick

      ? String(myData.guessPick).trim()

      : "";

  const effectivePick = myPick || pickPending || "";

  const didCurrentUserGuessLie = useMemo(() => {
    if (!me || !subjectUserId || me === subjectUserId) return false;
    const meDoc = userMap.get(me);
    const meEpoch = Number(meDoc?.guessEpoch ?? 0) || 0;
    const syncedPick =
      meEpoch === guessEpoch ? String(meDoc?.guessPick ?? "").trim() : "";
    const localPick = String(effectivePick ?? "").trim();
    return syncedPick === "lie" || localPick === "lie";
  }, [me, subjectUserId, userMap, guessEpoch, effectivePick]);



  useEffect(() => {

    setPickPending(null);

  }, [guessEpoch, subjectUserId]);



  useEffect(() => {

    if (myPick && pickPending && myPick === pickPending) {

      setPickPending(null);

    }

  }, [myPick, pickPending]);



  const allEligiblePickedLie = useMemo(() => {

    if (!subjectUserId || !eligibleGuessers.length) return false;

    return eligibleGuessers.every((id) => {

      const d = userMap.get(id);

      if (!d) return false;

      const ge = Number(d.guessEpoch ?? 0) || 0;

      const pick = String(d.guessPick ?? "").trim();

      return ge === guessEpoch && pick === "lie";

    });

  }, [eligibleGuessers, userMap, subjectUserId, guessEpoch]);

  const allEligibleSubmittedPick = useMemo(() => {

    if (!subjectUserId || !eligibleGuessers.length) return false;

    return eligibleGuessers.every((id) => {

      const d = userMap.get(id);

      if (!d) return false;

      const ge = Number(d.guessEpoch ?? 0) || 0;

      const pick = String(d.guessPick ?? "").trim();

      return ge === guessEpoch && SLOT_KEYS.includes(pick);

    });

  }, [eligibleGuessers, userMap, subjectUserId, guessEpoch]);



  const showUnanimousLieMessage =

    Boolean(subjectUserId) &&

    me === subjectUserId &&

    allEligiblePickedLie &&

    eligibleGuessers.length > 0;



  const roundKey =

    subjectUserId && guessEpoch

      ? `${subjectUserId}|${guessEpoch}`

      : "";

  const roundEndMs = resolveRoundEndMs(roomData);

  /** Same wall-clock rule for picking vs revealing (avoids blocking when UI shows "0s" but round is still open). */

  const roundTimerExpired =

    roundEndMs != null && Date.now() >= roundEndMs;

  const guessWindowClosed = (roundEndMs != null && roundTimerExpired) || allEligibleSubmittedPick;

  /** Truth/lie faces + result icons once time is up OR everyone has submitted a pick. */

  const revealTruthLie = Boolean(roundKey) && (roundTimerExpired || allEligibleSubmittedPick);

  useEffect(() => {
    if (!revealTruthLie || !roundKey) {
      setShowConfetti(false);
      return;
    }

    const guessedLieCorrectly = didCurrentUserGuessLie;

    if (!guessedLieCorrectly) {
      setShowConfetti(false);
      return;
    }

    if (confettiRoundKeyRef.current === roundKey) return;

    confettiRoundKeyRef.current = roundKey;
    setShowConfetti(true);
    const id = window.setTimeout(() => {
      setShowConfetti(false);
    }, 3000);

    return () => window.clearTimeout(id);
  }, [revealTruthLie, roundKey, didCurrentUserGuessLie]);



  /** Per statement slot: guesser ids who picked it this epoch (visible to everyone, including spotlight player). */

  const livePickersBySlot = useMemo(() => {

    const bySlot = { truth1: [], truth2: [], lie: [] };

    if (!subjectUserId) return bySlot;

    for (const id of eligibleGuessersSorted) {

      const d = userMap.get(id);

      let pick = "";

      if (id === me && pickPending && !revealTruthLie) {

        pick = String(pickPending).trim();

      } else if (d) {

        const ge = Number(d.guessEpoch ?? 0) || 0;

        const p = String(d.guessPick ?? "").trim();

        if (ge === guessEpoch && SLOT_KEYS.includes(p)) pick = p;

      }

      if (pick && bySlot[pick]) bySlot[pick].push(id);

    }

    return bySlot;

  }, [

    subjectUserId,

    eligibleGuessersSorted,

    userMap,

    guessEpoch,

    me,

    pickPending,

    revealTruthLie,

  ]);



  /** After reveal: how many eligible guessers picked the lie this epoch (vs total eligible). */

  const revealRoundGuessTally = useMemo(() => {

    if (!subjectUserId) {

      return {

        correctLieGuesses: 0,

        eligibleCount: 0,

        submittedCount: 0,

        missingPicks: 0,

      };

    }

    let correctLieGuesses = 0;

    let submittedCount = 0;

    const eligibleCount = eligibleGuessers.length;

    for (const id of eligibleGuessers) {

      const d = userMap.get(id);

      if (!d) continue;

      const ge = Number(d.guessEpoch ?? 0) || 0;

      const pick = String(d.guessPick ?? "").trim();

      if (ge !== guessEpoch) continue;

      if (!SLOT_KEYS.includes(pick)) continue;

      submittedCount += 1;

      if (pick === "lie") correctLieGuesses += 1;

    }

    const missingPicks = Math.max(0, eligibleCount - submittedCount);

    return { correctLieGuesses, eligibleCount, submittedCount, missingPicks };

  }, [eligibleGuessers, userMap, guessEpoch, subjectUserId]);



  /** After reveal (for spotlight): each guesser who submitted, with pick text. */

  const revealGuessBreakdown = useMemo(() => {

    if (!subjectUserId) return [];

    const doc = userMap.get(subjectUserId);

    if (!doc || !hasCompleteStatements(doc)) return [];

    const rows = [];

    for (const id of eligibleGuessers) {

      const d = userMap.get(id);

      if (!d) continue;

      const ge = Number(d.guessEpoch ?? 0) || 0;

      const pick = String(d.guessPick ?? "").trim();

      if (ge !== guessEpoch || !SLOT_KEYS.includes(pick)) continue;

      rows.push({

        userId: id,

        name: displayNameForUser(id, d),

        pick,

        correct: pick === "lie",

        pickedText: String(doc[pick] ?? "").trim() || "—",

        score: truthScoreFromUserData(d),

      });

    }

    rows.sort((a, b) => {

      if (a.correct !== b.correct) return Number(b.correct) - Number(a.correct);

      return a.name.localeCompare(b.name, undefined, { sensitivity: "base" });

    });

    return rows;

  }, [eligibleGuessers, userMap, guessEpoch, subjectUserId]);



  const userDataCount = useMemo(
    () => countUsersWithCompleteStatements(userMap),
    [userMap]
  );

  /** Must match "Round X of Y" in the header: one spotlight round per user with full statements, not `statementOrder.length` (can be a stale short list in Firestore). */
  const roundTotal = userDataCount || 1;

  const roundDisplay =

    roundTotal > 0 ? Math.min(roundIdx + 1, roundTotal) : 1;

  const roomUserCount = Number(roomData?.userCount ?? 0) || 0;

  const isFinalSpotlightRound =

    userDataCount > 0 && roundIdx >= userDataCount - 1;

  /** Next when results visible; last round is when all spotlight rounds (per complete-statement user) are done. */
  const isLastEligibleRound =

    userDataCount > 0 && roundIdx >= userDataCount - 1;

  const showPresenterNextAfterReveal =

    revealTruthLie && !isLastEligibleRound && userDataCount > 0;

  const showPresenterEndGame =

    userDataCount > 0 &&

    roomUserCount === userDataCount &&

    isFinalSpotlightRound &&

    guessWindowClosed;

  const shouldShowRoundTimer =

    isShowStatus && roundSecondsLeft >= 0;



  const pinLabel = roomId.length > 5 ? roomId.slice(-5) : roomId;

  const origin =

    typeof window !== "undefined" ? window.location.origin : "";



  useLayoutEffect(() => {

    const endMs = resolveRoundEndMs(roomData);

    if (endMs == null) {

      setRoundSecondsLeft(-1);
      setTimerStarted(false);

      return;

    }

    setRoundSecondsLeft(Math.max(0, Math.ceil((endMs - Date.now()) / 1000)));
    setTimerStarted(true);

  }, [roomData?.gameRoundEndsAt, roomData?.gameGuessEpoch, roomData?.gameRoundIdx]);



  useEffect(() => {

    const endMs = resolveRoundEndMs(roomData);

    if (endMs == null) return undefined;

    const tick = () => {

      setRoundSecondsLeft(Math.max(0, Math.ceil((endMs - Date.now()) / 1000)));

    };

    tick();

    const id = window.setInterval(tick, 250);

    return () => window.clearInterval(id);

  }, [roomData?.gameRoundEndsAt, roomData?.gameGuessEpoch, roomData?.gameRoundIdx]);



  useEffect(() => {

    if (!isPresenter || !sessionId || !roomId) return;

    if (storedRoomStatus !== "show") return;

    if (roomData?.gameFinished) return;

    const endMs = resolveRoundEndMs(roomData);

    if (endMs == null) return;

    if (Date.now() < endMs) return;

    const ord = Array.isArray(roomData?.gameStatementOrder)

      ? roomData.gameStatementOrder.map((id) => String(id).trim()).filter(Boolean)

      : [];

    const idx = Math.max(0, Number(roomData?.gameRoundIdx ?? 0) || 0);

    const cur = String(ord[idx] ?? roomData?.gameSubjectUserId ?? "").trim();

    if (!cur) return;

    const epoch = Number(roomData?.gameGuessEpoch ?? 1) || 1;

    const scoreKey = `${cur}|${epoch}`;

    if (String(roomData?.gameLastScoredKey ?? "").trim() === scoreKey) return;

    if (scoringFlightRef.current) return;

    scoringFlightRef.current = true;

    void (async () => {

      try {

        const eligible = buildEligibleGuessersForSubject(userMap, cur);

        const { deltas } = computeTruthRoundScores({

          eligibleGuessers: eligible,

          userMap,

          subjectUserId: cur,

          guessEpoch: epoch,

          bonusOnly: true,

        });

        const isLastRoundIdx = ord.length > 0 && idx >= ord.length - 1;

        const roster = countUsersWithCompleteStatements(userMap);

        const timerScoreRoomPatch = {

          gameLastScoredKey: scoreKey,

          gameRoundUpdatedAt: serverTimestamp(),

          ...(isLastRoundIdx && roster > 0 ? { userCount: roster } : {}),

        };

        if (deltas.size > 0) {

          await commitScoreDeltas({

            db: database,

            sessionId,

            roomId,

            deltas,

            roomPatch: timerScoreRoomPatch,

            userMap,

            truthLobby,

          });

        } else {

          await setDoc(

            doc(database, LOBBY_COLLECTION, sessionId, "rooms", roomId),

            timerScoreRoomPatch,

            { merge: true }

          );

        }

      } catch (e) {

        console.error("game timer score:", e);

      } finally {

        scoringFlightRef.current = false;

      }

    })();

  }, [

    isPresenter,

    sessionId,

    roomId,

    roomData,

    userMap,

    storedRoomStatus,

  ]);

  /** Auto-end round when all eligible users have submitted a pick (presenter only). */
  useEffect(() => {
    if (!isPresenter || !sessionId || !roomId) return;
    if (storedRoomStatus !== "show") return;
    if (roomData?.gameFinished) return;
    if (!allEligibleSubmittedPick) return;
    if (!subjectUserId) return;

    const ord = Array.isArray(roomData?.gameStatementOrder)
      ? roomData.gameStatementOrder.map((id) => String(id).trim()).filter(Boolean)
      : [];
    const idx = Math.max(0, Number(roomData?.gameRoundIdx ?? 0) || 0);
    const cur = String(ord[idx] ?? roomData?.gameSubjectUserId ?? "").trim();
    if (!cur) return;

    const epoch = Number(roomData?.gameGuessEpoch ?? 1) || 1;
    const scoreKey = `${cur}|${epoch}`;
    if (String(roomData?.gameLastScoredKey ?? "").trim() === scoreKey) return;
    if (scoringFlightRef.current) return;

    // Only proceed if the round hasn't already been ended by timer
    const endMs = resolveRoundEndMs(roomData);
    if (endMs != null && Date.now() >= endMs) return; // Timer already expired

    scoringFlightRef.current = true;
    void (async () => {
      try {
        const eligible = buildEligibleGuessersForSubject(userMap, cur);
        const { deltas } = computeTruthRoundScores({
          eligibleGuessers: eligible,
          userMap,
          subjectUserId: cur,
          guessEpoch: epoch,
          bonusOnly: true,
        });

        const isLastRoundIdx = ord.length > 0 && idx >= ord.length - 1;
        const roster = countUsersWithCompleteStatements(userMap);

        const allGuessedScoreRoomPatch = {
          gameLastScoredKey: scoreKey,
          gameRoundUpdatedAt: serverTimestamp(),
          gameRoundEndsAt: Timestamp.fromMillis(Date.now()), // End the round now
          fillEndedAllGuessedAt: serverTimestamp(),
          ...(isLastRoundIdx && roster > 0 ? { userCount: roster } : {}),
        };

        if (deltas.size > 0) {
          await commitScoreDeltas({
            db: database,
            sessionId,
            roomId,
            deltas,
            roomPatch: allGuessedScoreRoomPatch,
            userMap,
            truthLobby,
          });
        } else {
          await setDoc(
            doc(database, LOBBY_COLLECTION, sessionId, "rooms", roomId),
            allGuessedScoreRoomPatch,
            { merge: true }
          );
        }
      } catch (e) {
        console.error("game all guessed score:", e);
      } finally {
        scoringFlightRef.current = false;
      }
    })();
  }, [
    isPresenter,
    sessionId,
    roomId,
    storedRoomStatus,
    roomData,
    userMap,
    allEligibleSubmittedPick,
    subjectUserId,
    truthLobby,
  ]);



  const initGameRoundsIfNeeded = useCallback(async () => {

    if (!isPresenter || !sessionId || !roomId) return;

    if (!isTruthGamePlayPhase(roomStatus)) return;

    if (!subjectsOrdered.length) return;

    if (roomData?.gameFinished) return;

    const ord = roomData?.gameStatementOrder;

    if (Array.isArray(ord) && ord.length > 0) return;

    if (initGameRef.current) return;

    initGameRef.current = true;

    const order = shuffleUserIds(subjectsOrdered);

    const first = order[0];

    const dur =

      Number(roomData?.gameRoundDurationSeconds) > 0

        ? Math.floor(Number(roomData.gameRoundDurationSeconds))

        : DEFAULT_ROUND_SECONDS;

    const ends = Date.now() + dur * 1000;

    try {

      await setDoc(

        doc(database, LOBBY_COLLECTION, sessionId, "rooms", roomId),

        {

          gameStatementOrder: order,

          gameRoundIdx: 0,

          gameSubjectUserId: first,

          gameGuessEpoch: 1,

          gameRoundEndsAt: Timestamp.fromMillis(ends),

          gameRoundStartedAt: serverTimestamp(),

          gameRoundDurationSeconds: dur,

          gameLastScoredKey: "",

          userCount: 0,

          gameRoundUpdatedAt: serverTimestamp(),

        },

        { merge: true }

      );

    } catch (e) {

      console.error("game init rounds:", e);

      initGameRef.current = false;

    }

  }, [

    isPresenter,

    sessionId,

    roomId,

    subjectsOrdered,

    roomData?.gameStatementOrder,

    roomData?.gameFinished,

    roomData?.gameRoundDurationSeconds,

    roomStatus,

  ]);



  useEffect(() => {

    void initGameRoundsIfNeeded();

  }, [initGameRoundsIfNeeded]);



  const handleEndGame = useCallback(async () => {

    if (!isPresenter || !sessionId || !roomId || nextBusy) return;

    if (roomData?.gameFinished) return;

    setNextBusy(true);

    try {

      await setDoc(

        doc(database, LOBBY_COLLECTION, sessionId, "rooms", roomId),

        {

          gameFinished: true,

          gameRoundUpdatedAt: serverTimestamp(),

        },

        { merge: true }

      );

    } catch (e) {

      console.error("game end:", e);

    } finally {

      setNextBusy(false);

    }

  }, [isPresenter, sessionId, roomId, nextBusy, roomData?.gameFinished]);



  const handleStartShow = useCallback(async () => {

    if (!isPresenter || !sessionId || !roomId || nextBusy) return;

    if (storedRoomStatus !== "holding") return;

    const dur =

      Number(roomData?.gameRoundDurationSeconds) > 0

        ? Math.floor(Number(roomData.gameRoundDurationSeconds))

        : DEFAULT_ROUND_SECONDS;

    const ends = Date.now() + dur * 1000;

    // Immediately update local timer state for instant feedback
    setRoundSecondsLeft(dur);
    setTimerStarted(true);

    setNextBusy(true);

    try {

      await setDoc(

        doc(database, LOBBY_COLLECTION, sessionId, "rooms", roomId),

        {

          status: "show",

          statusUpdatedAt: serverTimestamp(),

          gameRoundEndsAt: Timestamp.fromMillis(ends),

          gameRoundStartedAt: serverTimestamp(),

          gameRoundUpdatedAt: serverTimestamp(),

        },

        { merge: true }

      );

    } catch (e) {

      console.error("game start show:", e);

    } finally {

      setNextBusy(false);

    }

  }, [

    isPresenter,

    sessionId,

    roomId,

    nextBusy,

    storedRoomStatus,

    roomData?.gameRoundDurationSeconds,

    setRoundSecondsLeft,

  ]);



  const handleNextRound = useCallback(async () => {

    if (!isPresenter || !sessionId || !roomId || nextBusy) return;

    setNextBusy(true);

    try {

      if (storedRoomStatus !== "show") return;

      const liveSubjects = [];

      userMap.forEach((data, id) => {

        if (hasCompleteStatements(data)) liveSubjects.push(String(id).trim());

      });

      liveSubjects.sort();

      if (!liveSubjects.length) return;



      const storedOrder = Array.isArray(roomData?.gameStatementOrder)

        ? roomData.gameStatementOrder.map((id) => String(id).trim()).filter(Boolean)

        : [];

      const liveSet = new Set(liveSubjects);

      const mergedOrder = [];

      for (const id of storedOrder) {

        if (liveSet.has(id)) mergedOrder.push(id);

      }

      for (const id of liveSubjects) {

        if (!mergedOrder.includes(id)) mergedOrder.push(id);

      }

      if (!mergedOrder.length) return;



      /** Host can advance anytime: score this round if needed, then next subject + full timer reset. */

      scoringFlightRef.current = false;

      console.log("handleNextRound", {

        statementOrder,

        mergedOrder,

        subjectUserId,

        guessEpoch,

        roomData,

      });



      const idx = Math.max(0, Number(roomData?.gameRoundIdx ?? 0) || 0);

      const subjectFromRoom = String(roomData?.gameSubjectUserId ?? "").trim();

      const candidate = String(mergedOrder[idx] ?? subjectUserId ?? subjectFromRoom ?? "").trim();

      const cur = liveSet.has(candidate) ? candidate : String(mergedOrder[0] ?? "").trim();

      if (!cur) return;

      const curIdx = Math.max(0, mergedOrder.indexOf(cur));



      const scoreKey = `${cur}|${guessEpoch}`;

      const lastKey = String(roomData?.gameLastScoredKey ?? "").trim();

      const needScore = lastKey !== scoreKey;



      const eligible = buildEligibleGuessersForSubject(userMap, cur);

      const { deltas } = computeTruthRoundScores({

        eligibleGuessers: eligible,

        userMap,

        subjectUserId: cur,

        guessEpoch,

        bonusOnly: true,

      });



      const isLastRound = curIdx >= mergedOrder.length - 1;

      const roster = countUsersWithCompleteStatements(userMap);

      const dur =

        Number(roomData?.gameRoundDurationSeconds) > 0

          ? Math.floor(Number(roomData.gameRoundDurationSeconds))

          : DEFAULT_ROUND_SECONDS;



      const roomRef = doc(

        database,

        LOBBY_COLLECTION,

        sessionId,

        "rooms",

        roomId

      );



      const scoreRoomPatch = {

        gameLastScoredKey: scoreKey,

        gameRoundUpdatedAt: serverTimestamp(),

        ...(isLastRound && roster > 0 ? { userCount: roster } : {}),

      };



      if (needScore) {

        if (deltas.size > 0) {

          await commitScoreDeltas({

            db: database,

            sessionId,

            roomId,

            deltas,

            roomPatch: scoreRoomPatch,

            userMap,

            truthLobby,

          });

        } else {

          await setDoc(roomRef, scoreRoomPatch, { merge: true });

        }

      } else if (isLastRound && roster > 0) {

        await setDoc(

          roomRef,

          {

            userCount: roster,

            gameRoundUpdatedAt: serverTimestamp(),

          },

          { merge: true }

        );

      }



      if (isLastRound) return;



      // First end the current round to trigger reveal (like End Round button)
      await setDoc(
        roomRef,
        {
          gameRoundEndsAt: Timestamp.fromMillis(Date.now()),
          gameRoundUpdatedAt: serverTimestamp(),
        },
        { merge: true }
      );

      // Wait a moment for the reveal to show
      await new Promise(resolve => setTimeout(resolve, 100));

      const nextIdx = curIdx + 1;

      const nextSubject = String(mergedOrder[nextIdx] ?? "").trim();

      const nextEpoch = guessEpoch + 1;

      const ends = Date.now() + dur * 1000;

      setRoundSecondsLeft(dur);
      setTimerStarted(true);

      console.log("Next round calculation:", {

        currentIdx: curIdx,

        nextIdx,

        currentSubject: cur,

        nextSubject,

        mergedOrder,

        isLastRound

      });



      const batch = writeBatch(database);

      batch.set(

        roomRef,

        {

          status: "show",

          statusUpdatedAt: serverTimestamp(),

          gameStatementOrder: mergedOrder,

          gameRoundIdx: nextIdx,

          gameSubjectUserId: nextSubject,

          gameGuessEpoch: nextEpoch,

          gameRoundEndsAt: Timestamp.fromMillis(ends),

          gameRoundStartedAt: serverTimestamp(),

          gameLastScoredKey: "",

          userCount: roster,

          gameRoundUpdatedAt: serverTimestamp(),

        },

        { merge: true }

      );

      batchClearUserGuessPicks(

        batch,

        database,

        sessionId,

        roomId,

        Array.from(userMap.keys())

      );



      console.log("Committing batch with gameRoundIdx:", nextIdx);

      await batch.commit();

      console.log("Batch committed successfully");

    } catch (e) {

      console.error("game next round:", e);

    } finally {

      setNextBusy(false);

    }

  }, [

    isPresenter,

    sessionId,

    roomId,

    nextBusy,

    statementOrder,

    roomData?.gameRoundIdx,

    roomData?.gameLastScoredKey,

    roomData?.gameRoundEndsAt,

    roomData?.gameGuessEpoch,

    roomData?.gameRoundDurationSeconds,

    subjectUserId,

    guessEpoch,

    userMap,

    storedRoomStatus,

    setRoundSecondsLeft,

    setTimerStarted,

  ]);



  /** Presenter: full countdown again and new guess epoch so everyone can pick again. */

  const handleResetRoundTimer = useCallback(async () => {

    if (!isPresenter || !sessionId || !roomId || resetTimerBusy || nextBusy) return;

    if (storedRoomStatus !== "show") return;

    if (roomData?.gameFinished) return;

    if (!subjectUserId) return;

    const dur =

      Number(roomData?.gameRoundDurationSeconds) > 0

        ? Math.floor(Number(roomData.gameRoundDurationSeconds))

        : DEFAULT_ROUND_SECONDS;

    const nextEpoch = (Number(roomData?.gameGuessEpoch ?? 1) || 1) + 1;

    const ends = Date.now() + dur * 1000;

    setResetTimerBusy(true);

    try {

      await setDoc(

        doc(database, LOBBY_COLLECTION, sessionId, "rooms", roomId),

        {

          gameRoundEndsAt: Timestamp.fromMillis(ends),

          gameRoundStartedAt: serverTimestamp(),

          gameGuessEpoch: nextEpoch,

          gameLastScoredKey: "",

          gameRoundUpdatedAt: serverTimestamp(),

        },

        { merge: true }

      );

    } catch (e) {

      console.error("game reset round timer:", e);

    } finally {

      setResetTimerBusy(false);

    }

  }, [

    isPresenter,

    sessionId,

    roomId,

    resetTimerBusy,

    nextBusy,

    storedRoomStatus,

    roomData?.gameFinished,

    roomData?.gameRoundDurationSeconds,

    roomData?.gameGuessEpoch,

    subjectUserId,

  ]);



  const handleEndRoundEarly = useCallback(async () => {

    if (!isPresenter || !sessionId || !roomId || resetTimerBusy || nextBusy) return;

    if (storedRoomStatus !== "show") return;

    if (roomData?.gameFinished) return;

    if (!subjectUserId) return;

    setShowEndRoundOptions(true);

    setResetTimerBusy(true);

    try {

      // End the round immediately by setting gameRoundEndsAt to now

      await setDoc(

        doc(database, LOBBY_COLLECTION, sessionId, "rooms", roomId),

        {

          gameRoundEndsAt: Timestamp.fromMillis(Date.now()),

          gameRoundUpdatedAt: serverTimestamp(),

        },

        { merge: true }

      );

    } catch (e) {

      console.error("game end round early:", e);

    } finally {

      setResetTimerBusy(false);

    }

  }, [

    isPresenter,

    sessionId,

    roomId,

    resetTimerBusy,

    nextBusy,

    storedRoomStatus,

    roomData?.gameFinished,

    subjectUserId,

  ]);



  const handlePick = useCallback(



    async (slotKey) => {

      // alert("check");

      if (!me || !sessionId || !roomId || guessBusy) return;

      if (storedRoomStatus !== "show") return;

      if (me === subjectUserId) return;

      if (myPick || pickPending) return;

      if (!SLOT_KEYS.includes(slotKey)) return;

      flushSync(() => {

        setPickPending(slotKey);

        setGuessBusy(true);

      });

      try {

        const roundStartTime = roomData?.gameRoundStartedAt;

        let roundGuessSecs = 0;

        if (roundStartTime && typeof roundStartTime.toMillis === "function") {

          roundGuessSecs = Math.floor(

            (Date.now() - roundStartTime.toMillis()) / 1000

          );

        }

        roundGuessSecs = normalizeWholeSeconds(roundGuessSecs, 0);

        const mySnapData = me ? userMap.get(me) : null;

        const prevGuessTimeTotal = resolveTotalGuessSeconds(mySnapData);

        const cumulativeGuessTimeTotal =
          normalizeWholeSeconds(prevGuessTimeTotal + roundGuessSecs, 0);
        const guessingUserData = getUserDataForApi(me, userMap, truthLobby);
        const guessingUserScore = truthScoreFromUserData(mySnapData);
        const guessingUserTime = formatSecondsAsMmSs(cumulativeGuessTimeTotal);

        await setDoc(

          doc(

            database,

            LOBBY_COLLECTION,

            sessionId,

            "rooms",

            roomId,

            LOBBY_USERDATA,

            me

          ),

          {

            guessEpoch,

            guessPick: slotKey,

            guessedAt: serverTimestamp(),

            guessTimeSeconds: roundGuessSecs,

            truthGameGuessTimeSecondsTotal: increment(roundGuessSecs),

          },

          { merge: true }

        );



        const pickDeltas = new Map();

        if (slotKey === "lie") {

          await setDoc(

            doc(

              database,

              LOBBY_COLLECTION,

              sessionId,

              "rooms",

              roomId,

              LOBBY_USERDATA,

              me

            ),

            {

              lastGuessTimeSeconds: cumulativeGuessTimeTotal,

              truthGameScore: increment(SCORE_CORRECT_GUESS),

              truthGameScoreUpdatedAt: serverTimestamp(),

            },

            { merge: true }

          );



          try {

            await updateScoreWithRole(

              guessingUserData,

              guessingUserScore + SCORE_CORRECT_GUESS,

              guessingUserTime

            );



            // Also update basic score

            // Get the statement text that was correctly guessed
            const subjectDoc = userMap.get(subjectUserId);
            const statementText = subjectDoc ? String(subjectDoc.lie || "").trim() : "";

            await updateScore({

              userId: me,

              sessionId: guessingUserData.sessionId,

              organizationId: guessingUserData.organizationId,

              points: guessingUserScore + SCORE_CORRECT_GUESS,

              time: guessingUserTime,

              statement: statementText

            });

          } catch (apiError) {

            console.error("Failed to update score for guessing user:", apiError);

          }

        } else if (subjectUserId) {

          pickDeltas.set(subjectUserId, SCORE_PER_PLAYER_FOOLED);



          // Update score via API for subject user (fooled player)

          try {

            const subjectUserData = getUserDataForApi(subjectUserId, userMap, truthLobby);

            const subjectUserDoc = userMap.get(subjectUserId);

            const currentScore = truthScoreFromUserData(subjectUserDoc);

            const subjectTime = formatSecondsAsMmSs(
              resolveTotalGuessSeconds(subjectUserDoc)
            );

            await updateScoreWithRole(
              subjectUserData,
              currentScore + SCORE_PER_PLAYER_FOOLED,
              subjectTime
            );

            // Also update basic score

            await updateScore({

              userId: subjectUserId,

              sessionId: subjectUserData.sessionId,

              organizationId: subjectUserData.organizationId,

              points: currentScore + SCORE_PER_PLAYER_FOOLED,

              time: subjectTime

            });

          } catch (apiError) {

            console.error("Failed to update score for subject user:", apiError);

          }

          // Keep guesser's API time in sync even when they guess the lie wrong.
          try {
            await updateScoreWithRole(
              guessingUserData,
              guessingUserScore,
              guessingUserTime
            );

            await updateScore({
              userId: me,
              sessionId: guessingUserData.sessionId,
              organizationId: guessingUserData.organizationId,
              points: guessingUserScore,
              time: guessingUserTime
            });
          } catch (apiError) {
            console.error("Failed to update score/time for wrong guess:", apiError);
          }

        }

        if (pickDeltas.size > 0) {

          await commitScoreDeltas({

            db: database,

            sessionId,

            roomId,

            deltas: pickDeltas,

            roomPatch: {

              gameRoundUpdatedAt: serverTimestamp(),

            },

            userMap,

            truthLobby,

          });

        } else if (slotKey === "lie") {

          await setDoc(

            doc(database, LOBBY_COLLECTION, sessionId, "rooms", roomId),

            { gameRoundUpdatedAt: serverTimestamp() },

            { merge: true }

          );

        }

      } catch (e) {

        console.error("game guess:", e);

        setPickPending(null);

      } finally {

        setGuessBusy(false);

      }

    },

    [

      me,

      sessionId,

      roomId,

      guessBusy,

      pickPending,

      subjectUserId,

      myPick,

      guessEpoch,

      storedRoomStatus,

      userMap,

      roomData,

      truthLobby,

    ]

  );



  const toggleFullscreen = useCallback(() => {

    const el = document.documentElement;

    if (!document.fullscreenElement) {

      void el.requestFullscreen?.();

    } else {

      void document.exitFullscreen?.();

    }

  }, []);



  const missingLobby = !sessionId || !roomId;



  if (missingLobby) {

    return (

      <div className="game">

        <div className="game__bg-glow" aria-hidden />

        <div className="game__empty">

          <p>No lobby in session.</p>

          <button

            type="button"

            className="game__cta"

            onClick={() => navigate("/userpage")}

          >

            Open lobby

          </button>

        </div>

      </div>

    );

  }



  const subjectAvatar = subjectUserId

    ? avatarIconForUserId(subjectUserId)

    : null;



  return (

    <div className={`game${hasPresenterDock ? " game--with-presenter-dock" : ""}`}>
      <MonkeyBackdrop />

      <div className="game__bg-glow" aria-hidden />

      <div className="game__bg-texture" aria-hidden />



      <header className="game__top">

        <div className="game__top-left">

          {/* <div className="game__url-line">

            {origin.replace(/^https?:\/\//, "")} 👈 {pinLabel}

          </div> */}

          <div className="game__round-line">

            Round {roundDisplay} of {roundTotal}

            {shouldShowRoundTimer ? (

              <span className="game__round-timer">

                {" · "}

                {roundSecondsLeft}s

              </span>

            ) : null}

          </div>

        </div>

      </header>



      {listenErr ? (

        <p className="game__error" role="alert">

          {listenErr}

        </p>

      ) : null}



      <div className="game__body">

        <div className="game__main-col">

          {!isShowPhase && !roomHydrated ? (

            <p className="game__hint" role="status">

              Loading room…

            </p>

          ) : !isShowPhase ? (

            <p className="game__hint" role="status">

              Statements and guessing appear when the room is in the game phase.

              If you just left the writing round, wait for the presenter to open the round.

            </p>

          ) : showHoldingHoldTight ? (

            <>

              <GameHoldTightPanel

                hint={holdingHoldTightHint}

                userMap={userMap}

              />

            </>

          ) : !subjectUserId ? (

            <p className="game__hint">

              {subjectsOrdered.length

                ? "Waiting for a spotlight player from the host…"

                : "Waiting for players to finish their statements."}

            </p>

          ) : (

            <div className="game__play-stage">

              <h1 className="game__prompt">

                <img

                  className="game__prompt-avatar"

                  src={subjectAvatar}

                  alt=""

                />

                {me === subjectUserId && !revealTruthLie ? (

                  <>Others are guessing your lie!</>

                ) : revealTruthLie ? (

                  <>

                    {allEligibleSubmittedPick
                      ? "Everyone picked — "
                      : "Time's up — "}

                    <span className="game__name-badge">{subjectName}</span>

                    &apos;s lie is revealed

                  </>

                ) : (

                  <>

                    Spot <span className="game__name-badge">{subjectName}</span>

                    &apos;s lie!

                  </>

                )}

              </h1>



              {eligibleGuessersSorted.length > 0 &&

                subjectDoc &&

                hasCompleteStatements(subjectDoc) ? (

                <div className="game__live-guessers" aria-label="Players guessing this round">

                  <span className="game__live-guessers-label">Guessing now</span>

                  <div className="game__live-guessers-row">

                    {eligibleGuessersSorted.map((id) => {
                      const userDoc = userMap.get(id);
                      const userGuessEpoch = Number(userDoc?.guessEpoch ?? 0) || 0;
                      const syncedPick =
                        userGuessEpoch === guessEpoch
                          ? String(userDoc?.guessPick ?? "").trim()
                          : "";
                      const pendingPick =
                        id === me && !revealTruthLie
                          ? String(pickPending ?? "").trim()
                          : "";
                      const effectiveChipPick =
                        pendingPick && SLOT_KEYS.includes(pendingPick)
                          ? pendingPick
                          : syncedPick;
                      const hasGuessed = SLOT_KEYS.includes(effectiveChipPick);

                      return (

                      <span

                        key={id}

                        className={`game__live-guesser-chip${hasGuessed ? " game__live-guesser-chip--filled" : ""}`}

                        title={displayNameForUser(id, userMap.get(id))}

                      >

                        <img

                          src={avatarIconForUserId(id)}

                          alt=""

                          width={40}

                          height={40}

                        />

                      </span>
                      );
                    })}

                  </div>

                </div>

              ) : null}



              {me === subjectUserId && !revealTruthLie ? (

                <div className="game__msg-overlay" role="status">

                  <h2>Everyone&apos;s guessing your lie!</h2>

                  <div className="game__msg-emoji" aria-hidden>

                    🤫

                  </div>

                  <p>The more people you fool, the more points you get!</p>

                </div>

              ) : null}



              {!subjectDoc || !hasCompleteStatements(subjectDoc) ? (

                <p className="game__hint" role="status">

                  Loading this player&apos;s statements…

                </p>

              ) : me === subjectUserId && !revealTruthLie ? (

                <p className="game__hint game__hint--subject-waiting" role="status">

                  Sit tight while others guess. Your three lines stay off your screen

                  until the timer ends — then you&apos;ll see the reveal with everyone

                  else.

                </p>

              ) : (

                <div

                  className={`game__cards${me === subjectUserId ? " game__cards--subject-reveal" : ""

                    }${revealTruthLie ? " game__cards--compact" : ""}${Boolean(effectivePick) ? " game__cards--locked" : ""

                    }`}

                >

                  {cardOrder.map((slot) => {

                    const text = String(subjectDoc?.[slot] ?? "").trim();

                    const isLieSlot = slot === "lie";

                    const cardTone = revealTruthLie

                      ? isLieSlot

                        ? "lie"

                        : "truth"

                      : "guess";

                    let resultKind = pickCardResultKind(slot, effectivePick);

                    if (
                      resultKind &&
                      revealTruthLie &&
                      !effectivePick
                    ) {
                      resultKind = "answer";
                    }

                    const pickedHere =

                      Boolean(effectivePick) && effectivePick === slot;

                    const selectedBeforeReveal = pickedHere && !revealTruthLie;

                    const pickedReveal = pickedHere && revealTruthLie;

                    const mutedSibling =

                      Boolean(effectivePick) &&

                      effectivePick !== slot &&

                      !revealTruthLie &&

                      cardTone === "guess";

                    const pickersHere = livePickersBySlot[slot] ?? [];

                    const showLivePickers =

                      pickersHere.length > 0 && (cardTone === "guess" || revealTruthLie);



                    return (

                      <button

                        key={`${slot}-${guessEpoch}`}

                        type="button"

                        aria-pressed={pickedHere}

                        className={`game__card game__card--${cardTone}${isLieSlot && revealTruthLie

                            ? " game__card--lie-highlight"

                            : ""

                          }${showLivePickers ? " game__card--has-live-pickers" : ""}${selectedBeforeReveal

                            ? " game__card--selected game__card--guess-locked"

                            : ""

                          }${mutedSibling ? " game__card--muted-sibling" : ""}${pickedHere ? " game__card--picked-zoom" : ""}${pickedReveal ? " game__card--picked" : ""

                          }${pickedReveal ? " game__card--picked-pulse" : ""}`}

                        disabled={

                          !isShowStatus ||

                          me === subjectUserId ||

                          Boolean(effectivePick) ||

                          guessBusy

                        }

                        onClick={() => void handlePick(slot)}

                      >

                        <div className="game__card-text">{text || "—"}</div>

                        {null}

                        {revealTruthLie && resultKind ? (

                          <CardResultFooter kind={resultKind} />

                        ) : null}

                        {revealTruthLie ? (

                          <CardRevealFaceBadge isLie={isLieSlot} />

                        ) : null}

                      </button>

                    );

                  })}

                </div>

              )}



              {/* Show guess count after user has guessed */}

              {effectivePick && !revealTruthLie && revealRoundGuessTally ? (

                <div className="game__guess-status" role="status">

                  <p>

                    You guessed! {revealRoundGuessTally.submittedCount} of {revealRoundGuessTally.eligibleCount} players have guessed so far.

                  </p>

                </div>

              ) : null}



              {revealTruthLie &&

                subjectUserId &&

                subjectDoc &&

                hasCompleteStatements(subjectDoc) ? (

                <div className="game__reveal-summary" role="region" aria-label="Round results">

                  {me !== subjectUserId ? (

                    <>

                      <p className="game__reveal-myscore" role="status">

                        Your score:{" "}

                        <strong>{truthScoreFromUserData(myData)}</strong> pts

                      </p>

                    </>

                  ) : null}

                  {me === subjectUserId ? (

                    <>

                      {revealRoundGuessTally.eligibleCount > 0 ? (

                        <p className="game__reveal-stats" role="status">

                          <strong>{revealRoundGuessTally.correctLieGuesses}</strong> of{" "}

                          <strong>{revealRoundGuessTally.eligibleCount}</strong>{" "}

                          {revealRoundGuessTally.eligibleCount === 1

                            ? "player"

                            : "players"}{" "}

                          spotted{" "}
                          {subjectName ? (
                            <>
                              <span className="game__name-badge">{subjectName}</span>
                              &apos;s lie.
                            </>
                          ) : (
                            "the lie."
                          )}

                          {revealRoundGuessTally.missingPicks > 0 ? (

                            <>

                              {" "}

                              ({revealRoundGuessTally.missingPicks}{" "}

                              {revealRoundGuessTally.missingPicks === 1

                                ? "player"

                                : "players"}{" "}

                              did not pick in time.)

                            </>

                          ) : null}

                        </p>

                      ) : (

                        <p className="game__reveal-stats" role="status">

                          No other players were eligible to guess this round.

                        </p>

                      )}

                      <p className="game__reveal-myscore" role="status">

                        Your score:{" "}

                        <strong>{truthScoreFromUserData(myData)}</strong> pts

                      </p>

                    </>

                  ) : null}

                  {revealGuessBreakdown.length > 0 ? (
                    <div className="game__reveal-messages">
                      {revealGuessBreakdown.slice(0, 3).map((row) => (
                        <p
                          key={row.userId}
                          className={`game__reveal-message ${row.correct ? "game__reveal-message--correct" : "game__reveal-message--fooled"}`}
                          role="status"
                        >
                          {generateRevealMessage(row.name, row.correct, subjectName)}
                        </p>
                      ))}
                    </div>
                  ) : null}

                </div>

              ) : null}



              {me === subjectUserId ? null : subjectDoc &&

                hasCompleteStatements(subjectDoc) ? (

                <>

                  {effectivePick ? (

                    <p className="game__hint">

                      {revealTruthLie
                        ? allEligibleSubmittedPick
                          ? "Everyone has picked - see how you did on the icons below your pick."
                          : roundTimerExpired
                            ? "Time's up - see how you did on the icons below your pick."
                            : "See how you did on the icons below your pick."

                        : "Locked in - waiting for other players or the timer."}

                    </p>

                  ) : revealTruthLie ? (

                    <p className="game__hint">

                      {allEligibleSubmittedPick
                        ? "Everyone has picked - the faces on the cards show which line was the lie."
                        : roundTimerExpired
                          ? "Time's up - the faces on the cards show which line was the lie."
                          : "The faces on the cards show which line was the lie."}

                    </p>

                  ) : (

                    <p className="game__hint">

                      Tap the statement you think is the lie.

                    </p>

                  )}

                  {presenterUserId && me === presenterUserId ? null : null}

                </>

              ) : null}

            </div>

          )}

        </div>

      </div>



      <div className="game__brand" aria-hidden>

        Truth &amp; Trick

      </div>



      {isPresenter && isHoldingStatus ? (

        <div className="game__presenter-dock" aria-label="Presenter controls">

          <div className="game__presenter-panel">

            <button

              type="button"

              className="game__presenter-icon-btn"

              aria-label={soundOn ? "Mute sound" : "Unmute sound"}

              onClick={() => setSoundOn((v) => !v)}

            >

              {soundOn ? "🔊" : "🔇"}

            </button>

            <button

              type="button"

              className="game__presenter-icon-btn"

              aria-label="Toggle fullscreen"

              onClick={toggleFullscreen}

            >

              ⛶

            </button>

            {/* <div className="game__autoplay">

              <button

                type="button"

                className={`game__switch${autoplayOn ? " game__switch--on" : ""}`}

                aria-pressed={autoplayOn}

                aria-label="Autoplay"

                onClick={() => setAutoplayOn((v) => !v)}

              />

              <span>Autoplay {autoplayOn ? "ON" : "OFF"}</span>

            </div> */}

            <button

              type="button"

              className="game__reset-timer"

              disabled={nextBusy}

              onClick={() => void handleStartShow()}

            >

              {nextBusy ? "Please wait…" : "Begin"}

            </button>

            <button

              type="button"

              className="game__next-round"

              disabled={true}
              title="Start the round with Begin first"

              onClick={() =>

                void (showPresenterEndGame ? handleEndGame() : handleNextRound())

              }

            >

              {nextBusy

                ? "Please wait…"

                : showPresenterEndGame

                  ? "End game"

                  : "Next round"}

            </button>

          </div>

        </div>

      ) : isPresenter && isShowStatus ? (

        <div className="game__presenter-dock" aria-label="Presenter controls">

          <div className="game__presenter-panel">

            <button

              type="button"

              className="game__presenter-icon-btn"

              aria-label={soundOn ? "Mute sound" : "Unmute sound"}

              onClick={() => setSoundOn((v) => !v)}

            >

              {soundOn ? "🔊" : "🔇"}

            </button>

            <button

              type="button"

              className="game__presenter-icon-btn"

              aria-label="Toggle fullscreen"

              onClick={toggleFullscreen}

            >

              ⛶

            </button>

            {/* <div className="game__autoplay">

              <button

                type="button"

                className={`game__switch${autoplayOn ? " game__switch--on" : ""}`}

                aria-pressed={autoplayOn}

                aria-label="Autoplay"

                onClick={() => setAutoplayOn((v) => !v)}

              />

              <span>Autoplay {autoplayOn ? "ON" : "OFF"}</span>

            </div> */}

            {/* Results visible: Next only after all eligible guessers picked; hidden on last round; End game always */}
            {revealTruthLie && (
              <>
                {showPresenterNextAfterReveal ? (
                  <button
                    type="button"
                    className="game__next-round"
                    disabled={nextBusy}
                    onClick={() => void handleNextRound()}
                  >
                    {nextBusy ? "Please wait…" : "Next Round"}
                  </button>
                ) : null}
                <button
                  type="button"
                  className="game__next-round"
                  disabled={nextBusy}
                  onClick={() => void handleEndGame()}
                >
                  {nextBusy ? "Please wait…" : "End game"}
                </button>
              </>
            )}

            {/* Guessing phase (truth/lie cards, no reveal yet): End round only */}
            {!revealTruthLie && (
              <button
                type="button"
                className="game__next-round"
                disabled={resetTimerBusy || nextBusy}
                onClick={() => void handleEndRoundEarly()}
              >
                {resetTimerBusy || nextBusy ? "Please wait…" : "End round"}
              </button>
            )}

          </div>

        </div>

      ) : null}



      {showConfetti && <LeaderboardConfetti soundEnabled={soundOn} />}

    </div>

  );

}



export default Game;

